import { createSelector } from '@reduxjs/toolkit';
import { getOrganization } from '../organization/getOrganization';

export const defaultNotesForShareVacation = createSelector(getOrganization, (organization): string => {
  if (organization === undefined) return '';
  return organization.vacationSummaryNotes;
});
